import AppBaseStore from './baseStore'
import { useDjango } from '@/composables/useDjango'
import type { BaseStoreActions, BaseStoreType } from '@/types/storeTypes'
import { SectionLineUploadCollection } from '@/stores/type/sectionLine.type'
import API from '@/api/apiUrls'
import { storeToRefs } from 'pinia'
import type { RasterFileUploadType } from '@/stores/type/rasterFileUpload.type'

const { api } = useDjango()

type State = BaseStoreType<RasterFileUploadType>

const baseUrl = API.SECTION_GEO_DATA.RASTER_FILE_UPLOAD.INDEX
const baseStore: BaseStoreType<RasterFileUploadType> = new AppBaseStore(baseUrl, api)
const baseStoreActions: BaseStoreActions<RasterFileUploadType> = baseStore.actions
const projectStore = useProjectStore()
const { currentItem: currentProject } = storeToRefs(projectStore)
export const useRasterFileUploadStore = defineStore({
  id: 'rasterFileUploads',
  state: (): State => ({
    ...baseStore.state,
    loading: false,
    filterFields: ['name'],
    addRasterFileDialog: false,
    selectedItems: []
  }),
  actions: {
    ...baseStoreActions,
    resetAll() {
      this.$reset()
    },
    addHiddenFieldToItems() {
      this.items.forEach((item) => {
        item.hidden = false
      })
    },
    toggleItem(item: SectionLineUploadCollection) {
      const obj = this.items.find((obj) => obj.id === item.id)
      obj.hidden = !obj.hidden
    },
    toggleAddRasterFileDialog(item: RasterFileUploadType = null) {
      if (item) this.setCurrentItem(item)
      this.addRasterFileDialog = !this.addRasterFileDialog
    },
    async createRasterFileUpload(fileName: string, collectionName: string, rasterColor: string) {
      return await this.create({
        source_file: fileName,
        project: currentProject.value.id,
        name: collectionName,
        raster_color: rasterColor
      })
    },
    toggleSelectedRasterFile(item: RasterFileUploadType) {
      const index = this.selectedItems.findIndex((selectedItem) => selectedItem.id === item.id)
      if (index !== -1) {
        this.selectedItems.splice(index, 1)
      } else {
        this.selectedItems.push(item)
      }
    },
    selectAllRasterFiles() {
      this.selectedItems = [...this.items]
    },
    clearSelectedRasterFiles() {
      this.selectedItems = []
    },
    async removeSelectedRasterFiles() {
      try {
        await this.bulkDelete(this.selectedItems)
        this.selectedItems = []
      } catch (error) {
        console.error('Failed to remove raster files:', error)
      }
    }
  },
  getters: {
    ...baseStore.getters,
    isSelectedAll(): boolean {
      return this.items.length ? this.selectedItems.length === this.items.length : false
    },
    isSelected: (state: State) => (id: number) => {
      return state.selectedItems.some((item) => item.id === id)
    }
  }
})
